<template>
    <div>
        <!--  <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div> -->
        <div class="mains">
            <div class="listCon flx alc" style="flex-wrap: wrap;">
                <div class="reItem" v-for="item,index in list" :style="(index + 1) % 4 == 0?'margin-right:0' : ''"
                    @click="toDetail(item)">
                    <div class="labelName" v-text="item.label" v-if="item.label"></div>
                    <div class="reImg">
                        <img :src="$img(item.avatar)" alt="" />
                        <div class="reimgMask" v-if="item.is_type == 2">
                            <img :src="$Localimg('play.png')" alt="">
                        </div>
                    </div>
                    <div class="reInfo">
                        <div class="reName multy2" v-text="item.name">

                        </div>
                        <div class="reTitle single" v-text="item.title">

                        </div>
                        <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                            <!-- <div class="rebtn" v-text="item.is_type == 2?'观看回放' : '马上预约'"></div> -->
                            <!-- (item.current_time < item.over_time) &&  -->
                            <div class="rebtn" v-if="item.is_type == 3">
                                马上预约
                            </div>
                            <div class="rebtn" v-if="item.is_type == 2">
                                观看回放
                            </div>
                            <div class="rebtn" v-if="item.is_type == 1">
                                了解课程
                            </div>
                            <div class="rebtn dsb" v-if="item.is_type == 4">
                                马上观看
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <el-pagination layout="prev, pager, next" :page-size="24" :current-page="page" @current-change="pageChange"
                :hide-on-single-page="true" :total="totals">
            </el-pagination>

        </div>
    </div>
</template>

<script>
    import {
        getLiveList
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"
    export default {
        components: {
            banner
        },
        data() {
            return {
                bannerList: [],
                page: 1,
                totals: 0,
                list: []
            }
        },
        created() {
            this.getIndex()
        },
        methods: {
            toDetail(e) {
                let that = this
                this.$router.push({
                    path: '/liveDetail', // 写路由path
                    query: {
                        type: e.is_type,
                        id: e.id
                    }
                })
            },
            pageChange(e) {
                let that = this
                that.page = e
                that.getIndex()
            },
            getIndex() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 24
                data.is_type = that.$route.query.type
                data.category_id = that.$route.query.id
                getLiveList(data).then((Res) => {
                    console.log(Res)
                    if (Res.code == 1) {
                        that.bannerList = Res.data.banner
                        that.list = Res.data.data
                        that.totals = Res.data.total
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .dsb {
        background: #9CA3AF;
    }

    .labelName {
        height: 29px;
        background: linear-gradient(79deg, #F59E0B 0%, #F4870A 100%);
        border-radius: 15px 15px 15px 2px;
        box-sizing: border-box;
        padding: 0 11px;
        line-height: 29px;
        position: absolute;
        left: 12px;
        top: 12px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
    }

    .reImg {
        width: 344px;
        height: 194px;
        position: relative;
        overflow-y:hidden
    }

    .reimgMask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
        background-color: rgba(0, 0, 0, .5);
    }

    .reimgMask img {
        width: 56px !important;
        height: 56px !important;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .reImg img {
        width: 100%;
        /* height: 100%; */
        /* object-fit: cover; */
    }

    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }

    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }

    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }

    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }

    .relist {
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        padding-bottom: 56px;
    }

    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        margin-right: 28px;
        position: relative;
    }

    .listCon {}

    .mains {
        width: 1460px;
        margin: 40px auto 0;
    }

    .titles {
        margin-bottom: 27px;
    }

    .checkmopre {
        width: 64px;
        /* height: 17px; */
    }

    .titleft {
        font-weight: 600;
        font-size: 24px;
        color: #000;
    }
</style>